<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .integration-modal-header {
    width: 100%;
  }

  .error-message {
    padding: utils.in_rem(16px);
    background-color: colors.get(interfaceSwGrey_10);
    @include mixins.body2();
    height: 100%;
  }
</style>

<script>
  import ConfirmNavigation from "@sourcewhale/shared/svelte-design-system/components/molecules/Modal/ConfirmNavigation.svelte";
  import Modal from "@sourcewhale/shared/svelte-design-system/components/molecules/Modal/Modal.svelte";
  import { showToast } from "@sourcewhale/shared/src/assets/js/src/general/utils";
  import Body from "./components/Body.svelte";
  import Header from "./components/Header.svelte";
  import {
    activeProviderConfigStore,
    activeProviderIsErrorStore,
    activeProviderModalStore,
    hasUnsavedChangesStore,
    providerConfigDraftStore,
    saveSettings,
  } from "./stores";

  $: if ($activeProviderModalStore && $activeProviderConfigStore) {
    providerConfigDraftStore.initialize(
      $activeProviderModalStore,
      $activeProviderConfigStore
    );
  }

  let showConfirmNavigation = false;

  const cancel = () => {
    showConfirmNavigation = false;
  };

  const confirm = () => {
    // Reset settings store to initial state
    providerConfigDraftStore.set({
      choices: {},
      customMap: {},
      lockedChoices: {},
      dataRefresh: {},
    });
    showConfirmNavigation = false;
    $activeProviderModalStore = null;
  };

  const confirmIfDirty = (f) =>
    f
      ? () => {
          if ($hasUnsavedChangesStore) {
            showConfirmNavigation = true;
            return null;
          }
          return f();
        }
      : null;

  const onclose = confirmIfDirty(() => {
    $activeProviderModalStore = null;
  });

  const onDeactivate = () => {
    // TODO: Implement deactivation using the provider from activeProviderModalStore
  };

  const onSave = async () => {
    if (!$activeProviderModalStore) return;

    const { provider } = $activeProviderModalStore;
    const success = await saveSettings(provider);

    if (success) {
      // Show success toast
      showToast({
        title: "Integration settings saved",
        type: "success",
      });

      $activeProviderModalStore = null;
    }
  };
</script>

{#if $activeProviderModalStore}
  <Modal {onclose} size="large" headerBorderBottom>
    <div class="integration-modal-header" slot="header">
      <Header {onDeactivate} {onSave} />
    </div>
    {#if $activeProviderIsErrorStore}
      <div class="error-message">
        An error occurred while fetching integration settings. You can
        deactivate the integration above, or contact support to continue using
        the integration.
      </div>
    {:else}
      <Body />
    {/if}
    {#if showConfirmNavigation}
      <ConfirmNavigation {confirm} {cancel}>
        <div slot="header">
          <h2>Discard unsaved changes</h2>
        </div>
        Would you like to discard these changes?
      </ConfirmNavigation>
    {/if}
  </Modal>
{/if}
